import { render, staticRenderFns } from "./ageChildrenReport.vue?vue&type=template&id=6ae2919d&scoped=true"
import script from "./ageChildrenReport.vue?vue&type=script&lang=js"
export * from "./ageChildrenReport.vue?vue&type=script&lang=js"
import style0 from "./ageChildrenReport.vue?vue&type=style&index=0&id=6ae2919d&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2919d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae2919d')) {
      api.createRecord('6ae2919d', component.options)
    } else {
      api.reload('6ae2919d', component.options)
    }
    module.hot.accept("./ageChildrenReport.vue?vue&type=template&id=6ae2919d&scoped=true", function () {
      api.rerender('6ae2919d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/ageChildrenReport/ageChildrenReport.vue"
export default component.exports